import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 상신문서 취소
 * @param body
 * @returns {Promise<axios.AxiosResponse<any>>}
 * @constructor
 */
const vacationApprovalCancel =(body)=>{
    return customAxios.post(myIpAddress+'/vacation/vacationApprovalCancel', body);
}
export default vacationApprovalCancel;